import { API_DOMAIN } from '../../utils/ApiUtil';

/** 补全收银台商品海报等媒体的相对路径，返回原图 URL（不做缩略图裁剪） */
export function resolveCashierMediaUrl(
  url: string | null | undefined
): string | undefined {
  const trimmed = url?.trim() ?? "";
  if (!trimmed) {
    return undefined;
  }
  if (/^https?:\/\//i.test(trimmed)) {
    return trimmed;
  }
  if (trimmed.startsWith("/")) {
    const domain = (API_DOMAIN ?? '').replace(/\/+$/, '');
    return domain ? `${domain}${trimmed}` : trimmed;
  }
  return trimmed;
}
